
import { defineComponent, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
    name: 'AuthCallback',
    setup() {
        const store = useStore()
        const router = useRouter()
        onBeforeMount(() =>
            store
                .dispatch('auth/oidcSignInCallback')
                .then((redirectPath: string) => {
                    router.push(redirectPath)
                })
                .catch((err: Error) => {
                    console.error(err)
                    router.push('/signin-oidc-error')
                })
        )
    },
})
